import { useSelector } from 'react-redux';
import Global from '../../store/global-selectors';

export const useContainsDemoOrder = (fulfillmentPlanIds = []) => {
  const gridSelectedFulfillmentPlanIds = useSelector(Global.selectSelectedOrdersIds);
  const selectedIds = fulfillmentPlanIds.length ? fulfillmentPlanIds : gridSelectedFulfillmentPlanIds;
  const selectedFulfillmentPlans = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlansByIds(state, {
      fulfillmentPlanIds: selectedIds,
    }),
  );

  if (!selectedFulfillmentPlans || selectedFulfillmentPlans.length === 0) {
    return false;
  }
  return selectedFulfillmentPlans.some((ffp) => ffp.isDemoOrder);
};
